export default {"src":"/_next/static/media/SFIX.611dd87d.svg","height":18,"width":18};